export default "__VITE_ASSET__INwxEIYS__"